'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';
import type { ExternalPackNftDto } from '~/lib/api';
import { Sheet, SheetContent, SheetTrigger } from '~/components/ui';
import { BaseCard } from '../base-card';
import { ExternalPackSheetContent } from './external-pack-sheet';

interface ExternalPackCardProps {
  externalNft: ExternalPackNftDto;
  className?: string;
}

export const ExternalPackCard = ({ externalNft, className }: ExternalPackCardProps) => {
  const t = useTranslations('workshop.staking');
  const [sheetOpen, setSheetOpen] = useState(false);
  const stakedTill = externalNft.stakedTill ?? null;
  const stakedTillDate = stakedTill ? new Date(stakedTill) : null;
  const isStaked = stakedTillDate ? stakedTillDate.getTime() > Date.now() : false;
  const daysLeft =
    isStaked && stakedTillDate
      ? Math.max(1, Math.ceil((stakedTillDate.getTime() - Date.now()) / (24 * 60 * 60 * 1000)))
      : null;

  const imageSource = externalNft.externalCollection.image ?? null;
  const title = externalNft.externalCollection.collectionName;

  return (
    <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
      <SheetTrigger asChild>
        <BaseCard
          className={className}
          imagePosition="contain"
          imageSrc={imageSource}
          isExternal
          overlayContent={
            isStaked ? (
              <div className="px-4 py-2 rounded-2xl bg-black/70 border border-white/10 text-white font-bold text-sm text-center">
                {daysLeft !== null ? t.rich('staked-days-left', { days: daysLeft, br: () => <br /> }) : t('staked')}
              </div>
            ) : null
          }
          title={title}
        />
      </SheetTrigger>
      <SheetContent className="rounded-t-3xl pb-10 flex flex-col">
        <ExternalPackSheetContent
          externalNft={externalNft}
          onSheetClose={() => {
            setSheetOpen(false);
          }}
        />
      </SheetContent>
    </Sheet>
  );
};
